import scanSuccessSound from '../../assets/sounds/Scann Success_coin_a.mp3';
import scanFailSound from '../../assets/sounds/scan_fail_shorter.mp3';
import notReady from '../../assets/sounds/not_ready.mp3';
import completeSound from '../../assets/sounds/_order_complete.mp3';
import setAsideTone from '../../assets/sounds/beep-03.mp3';
import AsyncStorage from '@react-native-async-storage/async-storage';


class AudioService {
  constructor() {
    this.sounds = {};
    this.isInitialized = false;

    // Default sound definitions
    this.defaultSoundMap = {
      success: scanSuccessSound,
      error: scanFailSound,
      notReady: notReady,
      complete: completeSound,
      setAside: setAsideTone
    };

    // Current sound map (can be updated with user selections)
    this.soundMap = { ...this.defaultSoundMap };
  }

  async initialize() {
    try {
      // Create audio instances
      Object.entries(this.soundMap).forEach(([key, src]) => {
        this.sounds[key] = new Audio(src);
        this.sounds[key].volume = 0.75;
        this.sounds[key].load();
      });

      this.isInitialized = true;
      console.log('AudioService initialized successfully');
    } catch (error) {
      console.error('AudioService initialization failed:', error);
    }
  }

  async loadUserSounds() {
    try {
      const correctScanSound = await AsyncStorage.getItem('correctScanType');
      const errorScanSound = await AsyncStorage.getItem('errorScanType');
      const orderScanSound = await AsyncStorage.getItem('orderScanType');

      // Update sound map with user selections (if available)
      if (correctScanSound) {
        this.soundMap.success = correctScanSound;
      }
      if (errorScanSound) {
        this.soundMap.error = errorScanSound;
      }
      if (orderScanSound) {
        this.soundMap.complete = orderScanSound;
      }

      // Reinitialize with new sounds
      await this.initialize();

      console.log('User sounds loaded successfully');
    } catch (error) {
      console.error('Failed to load user sounds:', error);
      // Fallback to default sounds
      await this.initialize();
    }
  }

  async initializeWithUserSounds() {
    await this.loadUserSounds();
  }

  async playSound(type) {
    if (!this.isInitialized) {
      console.warn('AudioService not initialized');
      return;
    }

    try {
      const sound = this.sounds[type];
      if (sound) {
        // Pause and reset if already playing
        sound.pause();
        sound.currentTime = 0;
        await sound.play();
      }
    } catch (error) {
      console.error(`Error playing ${type} sound:`, error);
    }
  }
  async playSuccessSound() {
    await this.playSound('success');
  }

  async playErrorSound() {
    await this.playSound('error');
  }

  async playNotReadySound() {
    await this.playSound('notReady');
  }

  async playCompleteSound() {
    await this.playSound('complete');
  }

  async playSetAsideSound() {
    await this.playSound('setAside');
  }

  pauseSound(type) {
    try {
      const sound = this.sounds[type];
      if (sound) {
        sound.pause();
      }
    } catch (error) {
      console.error(`Error pausing ${type} sound:`, error);
    }
  }

  pauseAll() {
    Object.keys(this.sounds).forEach(type => {
      this.pauseSound(type);
    });
  }

  cleanup() {
    Object.values(this.sounds).forEach(sound => {
      sound.pause();
      sound.currentTime = 0;
    });
    this.sounds = {};
    this.soundMap = { ...this.defaultSoundMap };
    this.isInitialized = false;
  }

  async resetToDefaults() {
    this.soundMap = { ...this.defaultSoundMap };
    await this.initialize();
  }
}

const audioService = new AudioService();
export default audioService;
